import { studentFinderActionsInterfaces, studentFinderActionTypes } from '.';
import { subjectForStudentListColumns } from '../../../settings/tableColumns';

type initStateType =
  studentFinderActionsInterfaces.StudentFinderState &
  studentFinderActionsInterfaces.SubjectListState;

const initState: initStateType = {
  loading: false,
  selectOpen: false,
  studentList: [],
  singleStudent: undefined,
  subjectForStudentList: {
    columns: subjectForStudentListColumns,
    data: [],
    loading: false,
    error: false,
    page: 1,
    totalPage: 0,
    totalRecords: 0,
    studentId: null,
  },
};

export default function authReducer(state: initStateType = initState, action: studentFinderActionsInterfaces.ActionTypes ): initStateType {
  switch (action.type) {
    case studentFinderActionTypes.GET_STUDENT_LIST:
      return {
        ...state,
        loading: true,
      };

    case studentFinderActionTypes.GET_STUDENT_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        selectOpen: true,
        studentList: action.payload.data.data,
      };

    case studentFinderActionTypes.GET_STUDENT_LIST_FAIL:
    case studentFinderActionTypes.GET_STUDENT_LIST_CANCEL:
      return {
        ...state,
        loading: false,
      };

    case studentFinderActionTypes.CHOOSE_SINGLE_STUDENT: {
      const student = state.studentList.find(student => student.studentId === action.payload.studentId);
      return {
        ...state,
        singleStudent: student,
      };
    }

    case studentFinderActionTypes.GET_SUBJECT_FOR_STUDENT_LIST:
      return {
        ...state,
        subjectForStudentList: {
          ...state.subjectForStudentList,
          loading: true,
        },
      };

    case studentFinderActionTypes.GET_SUBJECT_FOR_STUDENT_LIST_SUCCESS:
      return {
        ...state,
        subjectForStudentList: {
          ...state.subjectForStudentList,
          data: action.payload.data.data,
          error: false,
          loading: false,
          totalPage: action.payload.data.totalPages,
          totalRecords: action.payload.data.totalRecords,
          page: action.payload.data.page,
          studentId: action.payload.studentId,
        },
      };

    case studentFinderActionTypes.GET_SUBJECT_FOR_STUDENT_LIST_FAIL:
      return {
        ...state,
        subjectForStudentList: {
          ...state.subjectForStudentList,
          loading: true,
        },
      };

    case studentFinderActionTypes.RESET_REDUCER:
      return {
        ...initState,
      };

    case studentFinderActionTypes.CHANGE_SELECT_OPEN:
      return {
        ...state,
        selectOpen: action.payload.opened,
      };

    default:
      return state;
  }
}
